import { useEffect, useState } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const [isPowerFail, setIsPowerFail] = useState(false);
    const [isEntry, setIsEntry] = useState(false);

    useEffect(() => {
        setIsEntry(true);
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationJ',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '0%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', () => {
            setIsPowerFail(true);
        });

        sceneA1.on('leave', () => {
            setIsPowerFail(false);
        });

        controllerDelta2?.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationJ',
            offset: layoutH * 0.1, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationJ .msg-box',
            0.2,
            {
                top: 180,
                opacity: 0,
                ease: 'linear',
            },
            {
                top: 120,
                opacity: 1,
                ease: 'linear',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.animationJ .mask',
            0.2,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        const timelineA1 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 0);
        sceneA1.setTween(timelineA1);
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationJ} animationJ GtmModuleData-section`} data-section-id={css.animationJ} data-section-title={t('delta2.aniJ_msg1')}>
            <div className="sticky-box">
                <div className={`${isPowerFail ? 'power-fail' : ''} static-box`}>
                    <EFPic className={`light-img ${isEntry && isPowerFail ? 'light-ani' : ''}`} name={['animJ1.webp', 'animJ1.jpg']} />
                    <EFPic className={`night-img ${isEntry && isPowerFail ? 'night-ani' : ''}`} name={['animJ2.webp', 'animJ2.jpg']} />
                    <div className="mask"></div>
                    <div className="msg-box">
                        <div className="msg-title1">{t('delta2.aniJ_msg1')}</div>
                        <div className="msg-title2 title-bolder">{t('delta2.aniJ_msg2')}</div>
                        <div className="msg-title3">{t('delta2.aniJ_msg3')}</div>
                        {['cn', 'tw'].includes(locale) && <p className="msg-title4">{t('delta2.aniJ_msg4')}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}
